import style from './style.scss'

type Props = {
  children: React.ReactNode
}

function Wrapper({ children }: Props) {
  return <section className={style.wrapper}>{children}</section>
}

export default Wrapper
